import { Stack, Typography, Box } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikSwitch } from "../../../../../../shared/components/forms/Formik"
import { CompanyFormValues } from "../companyTypes"
import { tailwindPalette } from "../../../../../theme/tailwindPalette"

export function CompanySettingsAccordion() {
    return (
        <Stack direction="column" spacing={2}>
            <LocalizedStrict id="support-create-company-aside-active">
                <FormikSwitch<CompanyFormValues> name="isActive">Active:</FormikSwitch>
            </LocalizedStrict>
            <Box>
                <LocalizedStrict id="support-create-company-office-hotel-label">
                    <FormikSwitch<CompanyFormValues> name="isOfficeHotel">Office hotel:</FormikSwitch>
                </LocalizedStrict>
                <LocalizedStrict id="support-create-company-office-hotel-helper-text">
                    <Typography fontSize="small" color={tailwindPalette.neutral[500]}>
                        Helper text
                    </Typography>
                </LocalizedStrict>
            </Box>
        </Stack>
    )
}
